import React from "react";
import { ButtonBase, ThemeProvider, theme } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";
import LoginToDownloadModalSvg from "../../Icons/LoginToDownloadModalSvg";

const newTheme = {
  ...theme,
  variants: {},
};

export default function LoginModalComponent(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div className="absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900">
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className="relative border-b bg-gray-50">
            <div className="w-full absolute bottom-0 xl:inset-0 xl:h-full">
              <div className="h-full w-full xl:grid xl:grid-cols-2">
                <div className="h-full xl:relative xl:col-start-2 lg:flex items-end mx-auto hidden ">
                  <LoginToDownloadModalSvg />
                </div>
              </div>
            </div>
            <div className="px-4 lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8">
              <div className="relative py-6 text-left sm:py-6 lg:py-10">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
                <div className="mt-2 text-base text-gray-500">
                  {props.subHeading}
                </div>
              </div>
            </div>
          </div>
          <div className="p-4 lg:p-8 text-left max-w-lg">
            <div className="mt-2 text-base text-gray-500">
              {props.description}
            </div>
          </div>

          <div className="flex items-center p-8 border-t">
            <div className="w-full mr-2">
              <ButtonBase
                variant="primary"
                type="submit"
                label="Login"
                onClick={() => {
                  props.router.push("/login");
                  props.onAction("no");
                }}
                buttonBaseClasses={{
                  font: "text-sm font-medium",
                  backgroundColor: "bg-blue-600 hover:bg-blue-700",
                  textColor: "text-white",
                  border: "any",
                  width: "w-full",
                  padding: "px-4 py-3",
                }}
              />
            </div>
            <ButtonBase
              variant="primary"
              type="submit"
              label="cancel"
              onClick={() => props.onAction("no")}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-transparent",
                textColor: "text-black hover:text-blue-700",
                border: "border border-black border hover:border-blue-700",
                width: "w-full",
                padding: "px-4 py-3",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
